"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileButton = void 0;
var React = require("react");
var Button_1 = require("../Button");
var classNames = require("classnames");
var FileButton = /** @class */ (function (_super) {
    __extends(FileButton, _super);
    function FileButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, accept = _a.accept, onFileChange = _a.onFileChange, children = _a.children, onClick = _a.onClick, rest = __rest(_a, ["className", "accept", "onFileChange", "children", "onClick"]);
        return (React.createElement(Button_1.Button, __assign({ className: classNames('sok-file-button', className), onClick: function () { return _this.fileInput.click(); } }, rest),
            children,
            React.createElement("input", { ref: function (input) {
                    _this.fileInput = input;
                }, style: { display: 'none' }, type: "file", accept: accept, onChange: function (e) { return onFileChange(e); } })));
    };
    return FileButton;
}(React.Component));
exports.FileButton = FileButton;
//# sourceMappingURL=index.js.map